import { RMMClient } from '@nile/graphql';
import { useMutation } from '@apollo/client';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import {
  GET_ASSOCIATED_ASSETS,
  REMOVE_ASSOCIATION
} from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import {
  toast,
  NoDataCard,
  Loader,
  withErrorBoundary,
  AccessControl,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';
import { cloneDeep } from 'lodash';
import {
  Button,
  ResourceItem,
  ResourceList,
  TextStyle,
  Link
} from '@superops/ui-design-system';
import AssetTypeCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-type-cell';

function MonitoredAssetListNew(props) {
  const { assetId } = props?.match?.params;
  const { isRenderMonitoredAssets, entityName } = props;
  const { intl } = props;
  const tabContext = useContext(TicketContext);
  const [assetList, setAssetList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [tableBodyLoader, setTableBodyLoader] = useState(false);
  const pageSize = 25;
  const productType = useProduct();
  const [removeAssociation, { loading: removeLoading }] = useMutation(
    REMOVE_ASSOCIATION,
    {
      client: RMMClient,
      onCompleted() {
        toast('success', 'asset.details.itDoc.associateRemoved.success');
      },
      onError() {
        // toast('error', 'Something went wrong');
      }
    }
  );
  const removeAsset = (removedAssetId) => {
    const processedIds = [removedAssetId];
    removeAssociation({
      variables: {
        assetId: props.match.params?.assetId,
        relatedAsset: {
          entityName,
          assetIds: processedIds
        }
      }
    }).then((res) => {
      if (res?.data?.removeAssociation) {
        const clonedAssets = cloneDeep(assetList);
        const updatedAssets = clonedAssets.filter((asset) => {
          return processedIds.includes(asset.assetId.toString()) === false;
        });
        setAssetList(updatedAssets);
      }
    });
  };

  const navToDetailsPage = (asset) => {
    const { assetId: assetIdFromTable, name, assetClass } = asset;
    tabContext.openTab({
      module: 'ASSET_DETAILS',
      data: {
        id: assetIdFromTable,
        subject: name,
        classId: assetClass?.classId
      }
    });
  };
  const reFetchAssetList = (page) => {
    setActivePage(page);
    setTableBodyLoader(true);
    RMMClient.query({
      query: GET_ASSOCIATED_ASSETS,
      fetchPolicy: 'network-only',
      variables: {
        assetId: assetId,
        associatedEntityName: 'Asset',
        listInfo: {
          page,
          pageSize,
          sort: [
            {
              attribute: 'name',
              order: 'ASC'
            }
          ]
        }
      }
    })
      .then((res) => {
        setAssetList(res?.data?.getAssociatedAssetsV2?.assets);
        setTableBodyLoader(false);
      })
      .catch(() => setTableBodyLoader(false));
  };
  useEffect(() => {
    reFetchAssetList(activePage);
  }, [isRenderMonitoredAssets]);

  return (
    <div className="p20 pd-y0">
      {tableBodyLoader && <Loader />}
      {assetList.length ? (
        <ResourceList
          items={assetList || []}
          renderItem={(item) => {
            const { id, assetId: nonMonitorAssetId, name, client, site } = item;
            return (
              <ResourceItem id={id} name={name} gutter="md" key={id}>
                <div className="flex visibilityContainer pl5 actr">
                  <div className="w250">
                    <Link
                      onClick={() => navToDetailsPage(item)}
                      removeUnderline
                      fontWeight="bold"
                    >
                      <div className="flex actr">
                        <div className="mr-10 flex">
                          <AssetTypeCell cell={{ row: { original: item } }} />
                        </div>
                        {name}
                      </div>
                    </Link>
                  </div>
                  <TextStyle>
                    {productType === COMMON_CONSTANTS.MSP
                      ? client?.name
                      : site?.name || 'NA'}
                  </TextStyle>
                  <div className="mr-10 cp visibilityActions mlauto">
                    <AccessControl
                      roleToCheck="itDocumentation.edit"
                      render={
                        <Button
                          plainSecondary
                          icon={<SVGIcon name="RejectedCircle" />}
                          onClick={() => {
                            removeAsset(nonMonitorAssetId);
                          }}
                          loading={removeLoading}
                        />
                      }
                    />
                  </div>
                </div>
              </ResourceItem>
            );
          }}
        />
      ) : (
        <div className="flex full-height center jcenter mt25">
          <NoDataCard
            imageURL={`url(${envConfig.imageRoot}svg/not-found.svg)`}
            description={
              <FormattedMessage id="asset.details.itdocumentation.no.associated.assets" />
            }
          />
        </div>
      )}
    </div>
  );
}

export default withErrorBoundary(injectIntl(withRouter(MonitoredAssetListNew)));
